module.exports = __webpack_public_path__ + "img/4_seguridad.c751e74a.jpg";